
import { Component } from 'vue-property-decorator';
import VOpeningHourBundle from '@/components/shared/domain/VOpeningHoursBundle.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { OpeningHour } from '@/interfaces/models/OpeningHour';
import VSpecialOpeningHour from '@/components/shared/domain/VSpecialOpeningHour.vue';

@Component({
  components: { VOpeningHourBundle, VSpecialOpeningHour },
})
export default class OpeningHourForm extends mixins(StackedForm) {
  public $refs!: {
    specialOpeningHour: InstanceType<typeof VSpecialOpeningHour> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: any[], overwrite?: boolean) => void;
    };
    openingHour: InstanceType<typeof VOpeningHourBundle> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: OpeningHour[], overwrite?: boolean) => void;
    };
  };

  public openingHoursWeekdays: number[] = [];

  public async validate(): Promise<boolean> {
    const openingHours = await this.$refs.openingHour?.validate();
    const specialOpeningHours = await this.$refs.specialOpeningHour?.validate();

    return openingHours && specialOpeningHours;
  }

  public getData() {
    return {
      openingHours: this.$refs.openingHour.getHours(),
      specialOpeningHours: !!this.openingHoursWeekdays?.length
        ? this.$refs.specialOpeningHour?.getHours() ?? null
        : null,
    };
  }

  public setData(data: OpeningHour[]) {
    this.$refs.openingHour.setHours(data, true);
  }

  public onHandledTimeSlotChange(openingHours: OpeningHour[]) {
    this.openingHoursWeekdays = (openingHours || []).map((oh: OpeningHour) => oh.weekday);
  }

  public mounted(): void {
    if (this.initialValues) {
      const hasOpeningHours: boolean = !!(this.initialValues as any)?.openingHours?.length;
      this.onHandledTimeSlotChange((this.initialValues as any)?.openingHours || []);

      if (hasOpeningHours) {
        // @ts-ignore
        this.$refs.specialOpeningHour.setHours(this.initialValues.specialOpeningHours);
      }

      // @ts-ignore
      this.$refs.openingHour.setHours(this.initialValues.openingHours);
    }
  }
}
